import { memoize } from 'lodash';

import { stringsFor } from '../../location/locales';

export const getPriceRanges = memoize(localeCode => {
  const priceRangeLabels = stringsFor(localeCode).shingles.price_ranges;

  return priceRangeLabels
    .map((name, idx) => ({ uid: `${idx + 1}`, name, analyticsName: priceRangeLabels[idx] }))
    .reverse();
});

export default getPriceRanges;
